import {useCallback, useEffect, useState} from "react";
import "./PatientAdditionalDetailsComponent.scss";
import PatientAdditionalViewComponent from "./patient-additional-view/PatientAdditionalViewComponent";
import PatientAdditionalEditComponent from "./patient-additional-edit/PatientAdditionalEditComponent";

interface PatientAdditionalDetailsComponentProps {
    onUpdatePatientInformation: (details: any) => void;
    canEdit: boolean;
    patientDetails: any;
    onModeChange: (mode: "view" | "edit") => void;
}

const PatientAdditionalDetailsComponent = (props: PatientAdditionalDetailsComponentProps) => {
    const {onUpdatePatientInformation, canEdit, patientDetails, onModeChange} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");

    const handlePatientBasicInformationUpdate = useCallback((updatedPatientInformation: any,changeMode:boolean) => {
        onUpdatePatientInformation(updatedPatientInformation);
        changeMode && setMode("view");
    }, [onUpdatePatientInformation]);

    const handlePatientBasicInformationEditCancel = useCallback(() => {
        setMode("view");
    }, []);


    useEffect(() => {
        onModeChange(mode)
    }, [mode, onModeChange]);

    return (
        <div className={'patient-additional-details-component details-tab-data-wrapper'}>
            {
                mode === "view" && <PatientAdditionalViewComponent
                    patientDetails={patientDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <PatientAdditionalEditComponent patientDetails={patientDetails}
                                                                   onUpdateComplete={handlePatientBasicInformationUpdate}
                                                                   onEditCancel={handlePatientBasicInformationEditCancel}
                />
            }
        </div>
    );

};

export default PatientAdditionalDetailsComponent;
